import React from 'react';

interface ICircleCrossIconProps {
	size?: string;
}

export const CircleCrossIcon = ({ size = '24' }: ICircleCrossIconProps) => (
	<svg role="img" width={size} height={size} viewBox="0 0 24 24" fill="none" aria-labelledby="closeCircleCross">
		<title id="closeCircleCross">close cross</title>
		<path
			d="M5.63604 18.364C3.94821 16.6761 3 14.3869 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21C9.61305 21 7.32387 20.0518 5.63604 18.364Z"
			stroke="#3D3D3D"
			strokeWidth="2"
			strokeMiterlimit="10"
		/>
		<path d="M8 8L16 16" stroke="#3D3D3D" strokeWidth="2" strokeLinejoin="round" />
		<path d="M16 8L8 16" stroke="#3D3D3D" strokeWidth="2" strokeLinejoin="round" />
	</svg>
);
